export default {
    'query.queryCard.h1':'Мировая Платформа для отслеживания',
    'query.queryCard.p':'Система отслеживания грузов DawnTron предоставляет информацию о местонахождении грузов на протяжении всего процесса доставки, вы получаете точные данные о статусе отслеживания, точность запроса достигает 99%',
    'query.queryCard.placeholder':'Введите номер строки',
    'query.queryCard.submit':'запрос',
    'query.stepsCard.item01.title':'',
    'query.stepsCard.item01.desc':'Точное отслеживание в режиме реального времени',
    'query.stepsCard.item02.title':'',
    'query.stepsCard.item02.desc':'Эффективное таможенное оформление',
    'query.stepsCard.item03.title':'',
    'query.stepsCard.item03.desc':'Эксклюзивный сервис и индивидуальный подход',
    'query.stepsCard.item04.title':'',
    'query.stepsCard.item04.desc':'Гарантия качества и безопасности',
    'query.stepsCard.item05.title':'',
    'query.stepsCard.item05.desc':'Надежный высококлассный логистический провайдер',
}